import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
export default function () {
  extend(UserPage.prototype, 'navItems', function (items) {
    if (this.user && app.session.user && app.session.user.id() === this.user.id()) {
      items.add('ignored-users', m(LinkButton, {
        href: app.route('bizkaitarra.ignoredUsers'),
        icon: "fas fa-user-slash"
      }, app.translator.trans('bizkaitarra-ignore-users.forum.profile_link')));
      items.add('ignored-discussions', m(LinkButton, {
        href: app.route('bizkaitarra.ignoredDiscussions'),
        icon: "fas fa-eye-slash"
      }, app.translator.trans('bizkaitarra-ignore-users.forum.ignored_discussions_link')));
    }
  });
}